import qs from 'qs'
import { navigateTo, useHandleException } from '#imports'
import { useRedirectApi } from '~/composables/api/useRedirectApi'

const isDev = process.env.NODE_ENV === 'development'

/**
 * This redirect middleware must execute only on the client to handle navigation across the website and still has the redirects handled by Vue.
 */
export default defineNuxtRouteMiddleware(async (to) => {
  const { info } = console
  const requestUrl = useRequestURL()

  const { verify } = useVerifyTenantDomain()

  try {
    const { data } = await verify()

    if (data.domain !== requestUrl.origin) {
      const finalRedirectUrl = `${data.domain}${requestUrl.pathname}${requestUrl.search}`

      if (isDev) {
        info('Skip domain verification redirect on the dev environment', {
          originDomain: requestUrl.origin,
          redirectDomain: data.domain,
          finalRedirectUrl,
        })
      }
      else {
        return navigateTo(finalRedirectUrl, {
          redirectCode: 301,
          external: true,
        })
      }
    }
  }
  catch (ex: unknown) {
    useHandleException(ex)
  }

  if (!to?.name || !to?.path || to.path === '/') {
    return
  }

  /**
   * Prevent any non valid urls
   */
  if (to.path && to.path.toLowerCase() !== to.path) {
    let resultFullPath = `${to.path.toLowerCase()}`

    if (to.query && Object.keys(to.query).length > 0) {
      resultFullPath += `?${qs.stringify(to.query)}`
    }

    return navigateTo(resultFullPath, {
      redirectCode: 301,
    })
  }

  /**
   * Find the redirect in the database
   */
  if (requestUrl?.href) {
    try {
      const { view } = useRedirectApi()

      const { data } = await view(requestUrl.href)

      if (data?.destinationUrl) {
        return navigateTo(data.destinationUrl, {
          redirectCode: data.redirectType || 301,
          external: true,
        })
      }
    }
    catch (ex: unknown) {
      useHandleException(ex)
    }
  }
})
